import { useNavigate, useParams } from 'react-router-dom';

import useAdminProfile from '../../hooks/useAdminProfile';
import SettlementPcFrame, { accessMessage } from './SettlementPcFrame';
import {
  MESSAGES,
  buildSaleMonths,
  formatMonthDot,
  statementTitle,
  toPayoutMonth,
} from './settlementStatement.util';

/** 정산명세서 목록 PC(/:storeNo/settlement-statement). */
export default function SettlementListPc() {
  const { storeNo } = useParams();
  const navigate = useNavigate();
  const profileState = useAdminProfile();
  const months = buildSaleMonths();

  const notice = profileState.loading
    ? MESSAGES.loading
    : accessMessage(profileState, storeNo, MESSAGES) ??
      (months.length === 0 ? MESSAGES.empty : null);

  return (
    <SettlementPcFrame storeNo={storeNo}>
      <div className="settlement-pc__head">
        <h2 className="tit_01 settlement-pc__title">정산명세서</h2>
      </div>
      <article className="form_card list_card">
        <table className="table_box_01">
          <colgroup>
            <col />
            <col width="200px" />
          </colgroup>
          <thead>
            <tr>
              <th style={{ textAlign: 'left' }}>제목</th>
              <th>이용기간</th>
            </tr>
          </thead>
          <tbody>
            {notice !== null ? (
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>{notice}</td>
              </tr>
            ) : (
              months.map(month => (
                <tr
                  key={month}
                  className="notice-board__row"
                  onClick={() => navigate(`/${storeNo}/settlement-statement/${toPayoutMonth(month)}`)}
                >
                  <td style={{ textAlign: 'left' }}>
                    <span className="notice-board__title">{statementTitle(month)}</span>
                  </td>
                  <td>{formatMonthDot(month)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </article>
    </SettlementPcFrame>
  );
}
